import React from 'react';

import MustItem from '../../MustItem/MustItem';

const PostalCodeAreaTitle = props => {
  const title = '郵便番号を入力してください。';

  return (
    <div className="PostalCodeTitleContainer" >
      <div className="PostalCodeAreaTitle" >
        <MustItem />
        <div className="PostalCodeAreaTitleText" >
          {title}
        </div>
      </div>
      <div className="AlertHarf" >
        半角のみの入力となります。
      </div>
    </div>
  );
};

export default PostalCodeAreaTitle;
